module.exports = __webpack_public_path__ + "static/44-35158f94faf866e45133b4b6c0cac532.png";